import React from 'react';
import BuyerDashboard from './BuyerDashboard';
import ProcurementManagerDashboard from './ProcurementManagerDashboard';

function ProcurementDashboard({ user, dashboardData }) {
  // Helper function to determine if current user is a buyer (role 6)
  // Buyer role is 6, PM approver role is 4
  const isBuyer = () => {
    if (!user) return false;
    const roleCheck = user.role === 6 || user.role === '6';
    console.log('ProcurementDashboard - Checking if buyer:', { role: user.role, roleCheck });
    return roleCheck;
  };

  // Route to the appropriate dashboard based on user role
  if (isBuyer()) {
    return <BuyerDashboard user={user} dashboardData={dashboardData} />;
  }

  return <ProcurementManagerDashboard user={user} dashboardData={dashboardData} />;
}

export default ProcurementDashboard;
